import arkeoAirdrop from 'plugins/arkeo'
import avalanche from 'plugins/avalanche'
import bitcoin from 'plugins/bitcoin'
import bitcoincash from 'plugins/bitcoincash'
import cosmos from 'plugins/cosmos'
import dogecoin from 'plugins/dogecoin'
import ethereum from 'plugins/ethereum'
import foxPage from 'plugins/foxPage'
import litecoin from 'plugins/litecoin'
import mobile from 'plugins/mobile'
import optimism from 'plugins/optimism'
import osmosis from 'plugins/osmosis'
import pendo from 'plugins/pendo'
import thorchain from 'plugins/thorchain'
import walletConnectToDapps from 'plugins/walletConnectToDapps'

export const activePlugins = [
  bitcoin,
  bitcoincash,
  cosmos,
  dogecoin,
  litecoin,
  ethereum,
  foxPage,
  osmosis,
  avalanche,
  pendo,
  walletConnectToDapps,
  thorchain,
  mobile,
  optimism,
  arkeoAirdrop,
]
